import {makeEl} from "../../../common/Utils";
import DataStore from "../../DataStore";
import {infoType} from "../../../interface/IFooter";

export default class infoNCV{
    private ds : DataStore
  
    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
      
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        makeEl('address', _parent, {class: 'footer-info-address'}).innerHTML = `
            ${this.ds.l10n.infoCS.infoAddressNCV}
            `;

    }
}
